import { render, staticRenderFns } from "./FundaNowDetail.vue?vue&type=template&id=4ca13568&scoped=true&"
import script from "./FundaNowDetail.vue?vue&type=script&lang=js&"
export * from "./FundaNowDetail.vue?vue&type=script&lang=js&"
import style0 from "./FundaNowDetail.vue?vue&type=style&index=0&id=4ca13568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca13568",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDialog,VRow,VSpacer})
